import '../../styles/userEntry.scss';
import { NavLink, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useNotification } from '../../context/NotificationContext';
import LoaderBtn from '../LoaderBtn/LoaderBtn';
import { loginUser, resendCode } from '../../api/requests';
import { EyeOff, EyeIcon } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import 'animate.css';

const LoginArea = () => {
 const navigate = useNavigate();
 const { notify } = useNotification();
 const { authLogin } = useAuth();

 const [logInData, setLogInData] = useState({
  email: '',
  password: '',
  remember_me: false,
  showPassword: false,
  isLoading: false,
 });

 const handleInput = (key: string, value: string | boolean) => {
  setLogInData((prev) => {
   return {
    ...prev,
    [key]: value,
   };
  });
 };

 const setLoginLoader = (value: boolean) => {
  setLogInData((prev) => {
   return {
    ...prev,
    isLoading: value,
   };
  });
 };

 function isValidEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
 }

 const sendOtp = async () => {
  try {
   setLoginLoader(true);

   await resendCode(logInData.email);

   return true;
  } catch (error: any) {
   throw error;
  } finally {
   setLoginLoader(false);
  }
 };

 const HandleSignIn = async () => {
  if (logInData.email === '' || logInData.password === '') {
   notify.error('Please fill in the required fields to continue');
   return;
  }

  if (!isValidEmail(logInData.email)) {
   notify.error('Invalid e-mail address');
   return;
  }

  try {
   setLoginLoader(true);

   let result = await loginUser({
    email: logInData.email,
    password: logInData.password,
    user_type: 'customer',
   });

   let user_details = JSON.stringify(result.user_details);

   localStorage.setItem('user_details', user_details);

   await authLogin(result.access_token);

   notify.success('Sign-in successful');
  } catch (error: any) {
   let errMessage = error.message;

   if (errMessage === 'Email address not verified') {
    try {
     await sendOtp();

     let stateData = {
      email: logInData.email,
     };

     navigate('/signup/verify', {
      state: stateData,
     });
    } catch (error: any) {
     notify.error(error.message);
    }
   } else {
    notify.error(errMessage);
   }
  } finally {
   setLoginLoader(false);
  }
 };

 return (
  <div className="sectionarea">
   <div className="content animate__animated animate__fadeIn animate__fast">
    <NavLink to={'/'}>
     <div className="logoArea">
      <div className="icon logo_initials"></div>
      <div className="icon logo_name"></div>
     </div>
    </NavLink>

    <div className="intro">
     <div className="title">Login to your account</div>
     <div className="text">For business, band or celebrity.</div>
    </div>

    <div className="inputArea">
     <div className="inputPack">
      <label className="inputTitle">Email Address</label>
      <input
       className="inputBox"
       type="email"
       value={logInData.email}
       onChange={(ev) => handleInput('email', ev.currentTarget.value)}
      ></input>
     </div>

     <div className="inputPack">
      <label className="inputTitle">Password</label>
      <input
       className="inputBox"
       type={`${logInData.showPassword ? 'text' : 'password'}`}
       value={logInData.password}
       onChange={(ev) =>
        handleInput('password', ev.currentTarget.value)
       }
      ></input>

      <div className="eyepack">
       {logInData.showPassword && (
        <EyeOff
         onClick={() =>
          setLogInData((prev) => {
           return { ...prev, showPassword: !prev.showPassword };
          })
         }
        ></EyeOff>
       )}
       {!logInData.showPassword && (
        <EyeIcon
         onClick={() =>
          setLogInData((prev) => {
           return { ...prev, showPassword: !prev.showPassword };
          })
         }
        ></EyeIcon>
       )}
      </div>
     </div>
    </div>

    <div className="flex space-btw">
     <div className="flex">
      <input
       className="checkbox"
       type="checkbox"
       checked={logInData.remember_me}
       onChange={(ev) =>
        handleInput('remember_me', ev.currentTarget.checked)
       }
      ></input>
      <div className="rmem">Remember me</div>
     </div>

     <NavLink to="/signin/forgotpassword">
      <div className="fgpass">Forgot password?</div>
     </NavLink>
    </div>

    <div className="btn_grid">
     <LoaderBtn
      className={'btn'}
      text={'Log In'}
      thickness={3}
      isLoading={logInData.isLoading}
      clickFunction={HandleSignIn}
     ></LoaderBtn>

     {/* <div className='btn' onClick={HandleSignIn}>
                    Login
                </div> */}

     {/* <div className='btn google'>
                    <div className='google_icon'></div>
                    <span>Sign-in with google</span>
                </div> */}
    </div>

    <div className="flex_center tc">
     <NavLink to="/signup">
      <div className="crt_acc">
       Create An Account? <span className="highlight">Sign up</span>
      </div>
     </NavLink>
    </div>

    <div className="download_grid">
     <NavLink
      to={'https://apps.apple.com/app/yayako/id6744727249'}
      target="_blank"
     >
      <div className="appicon appstore"></div>
     </NavLink>
     <NavLink
      to={
       'https://play.google.com/store/apps/details?id=com.yayako.yayako'
      }
      target="_blank"
     >
      <div className="appicon googleplay"></div>
     </NavLink>
    </div>
   </div>
  </div>
 );
};

export default LoginArea;
